module.exports = __webpack_public_path__ + "static/img/111.314b81f.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/111.png
// module id = KujU
// module chunks = 1